import { render, staticRenderFns } from "./NewAnschreibenDialog.vue?vue&type=template&id=26ba6bb0&scoped=true"
import script from "./NewAnschreibenDialog.vue?vue&type=script&lang=js"
export * from "./NewAnschreibenDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ba6bb0",
  null
  
)

export default component.exports